<template>
    <div class="nano">
        <div class="ranking-content  nano-content"
             :class="{isHaveScroll:isHaveScroll}">
            <div v-for="(item,index) in value.arr" :key="index" class="line text-dark" :title="item.name"
                 @click="clickLine(item)">
                <svg width="6" height="14">
                    <polyline points="0,0 6,0 6,14 3,10 0,14 0,0" :style="svgStyle(index)"></polyline>
                </svg>
                <p :class="{'active': value.active === item.name}">{{item.name}}</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'ranking',
  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    },
    isHaveScroll: {
      type: Boolean,
      default: () => {
        return false
      }
    }
  },
  methods: {
    // svg 填充色 更改
    svgStyle (index) {
      let style = ''
      switch (index) {
        case 0:
          style = 'fill:#DE3939'
          break
        case 1:
          style = 'fill:#EC814E'
          break
        case 2:
          style = 'fill:#E9BD6B'
          break
        default:
          style = 'fill:#D0D7DF'
      }
      return style
    },
    clickLine (item) {
      this.value.active = item.name
      this.$emit('click', item)
    }
  }
}
</script>

<style scoped lang="less">
    .nano-content {
        &::-webkit-scrollbar {
            width: 0px;
        }
    }

    .ranking-content {
        width: 100%;
        height: 100%;
        /*overflow: hidden !important;*/
        /*display: flex;*/
        /*flex-direction: column;*/
        /*justify-content: space-between;*/


    }

    .isHaveScroll {
        &::-webkit-scrollbar {
            display: none !important; /* Chrome Safari */
        }
    }

    .line {
        display: flex;
        align-items: center;
        width: 100%;
        cursor: pointer;

        p {
            width: calc(100% - 6px - 5px);
            margin: 0 0 0 5px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-size: 14px;
        }

        .active {
            color: #208EFF;
        }
    }

    .line + .line {
        padding-top: 12px;
    }
</style>
